import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el MEGAPACK FUERZA MAYOR después de comprar?',
  a: 'Inmediatamente después de confirmar tu pago recibís un email con el enlace de descarga directa. Acceso instantáneo las 24 horas, los 7 días de la semana. En menos de 5 minutos tenés todo en tu dispositivo.'
}, {
  q: '¿Sirve para profes con poca experiencia trabajando con adultos mayores?',
  a: 'Sí. El Tomo 1 empieza desde cero con la evaluación inicial y el primer contacto con el alumno mayor. No necesitás experiencia previa específica. El sistema te guía paso a paso desde el primer día.'
}, {
  q: '¿Es editable? ¿Puedo modificarlo?',
  a: 'El material se entrega en formato PDF listo para usar. No es editable para proteger los derechos de autor, pero está diseñado para que lo uses tal cual sin necesidad de modificar nada.'
}, {
  q: '¿Los 6 bonos están en las dos ofertas?',
  a: 'Sí. Los 6 bonos estratégicos están incluidos en las dos opciones sin costo adicional. La diferencia entre las dos ofertas es que el Pack Completo incluye además el Patologías Pro™.'
}, {
  q: '¿Sirve si trabajo de forma individual o solo para grupos?',
  a: 'Sirve para los dos contextos. Los Tomos 1 al 4 son perfectos para trabajo individual y personalizado. El Tomo 5 está diseñado específicamente para clases grupales. El Tomo 6 aplica a cualquier contexto.'
}, {
  q: '¿Sirve si tengo alumnos con distintas patologías al mismo tiempo?',
  a: 'Exactamente para eso fue diseñado. La Guía de Variaciones en 3 Niveles y el Tomo 6 de Patologías te dan las herramientas para manejar grupos heterogéneos con distintas condiciones de salud de forma segura y profesional.'
}, {
  q: '¿Qué diferencia tiene con otros materiales sobre adultos mayores?',
  a: 'FUERZA MAYOR es el único sistema en Argentina creado específicamente para profes y kinesiólogos que trabajan con adultos mayores que incluye evaluación, clases listas, programación anual, adaptaciones por patología y herramientas de comunicación en un solo lugar. No es teoría: es práctica lista para aplicar desde hoy.'
}, {
  q: '¿Por qué elegir el PACK COMPLETO con Patologías Pro™ y no el estándar?',
  a: 'Si trabajás con adultos mayores, tarde o temprano vas a tener un alumno con artrosis, osteoporosis, hipertensión, Parkinson o post cirugía. El Patologías Pro™ te da los protocolos exactos para cada situación. Es la diferencia entre improvisar con miedo y actuar con seguridad y confianza.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días de garantía total. Abrís todo el material, lo usás en tus clases si querés, y si no es lo que esperabas te devolvemos el 100% del dinero sin preguntas ni formularios. Así de simple.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-10 md:py-20 px-4 bg-navy-50" data-id="element-61">
      <div className="max-w-3xl mx-auto" data-id="element-62">
        <h2 className="font-display text-3xl md:text-5xl text-navy-900 uppercase tracking-wide text-center mb-6 md:mb-12" data-id="element-63">
          PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-64">
          {faqs.map((faq, idx) => {
          const isOpen = openIndex === idx;
          return <div key={idx} className="bg-white border border-navy-100 rounded-xl overflow-hidden shadow-sm" data-id="element-65">
                <button onClick={() => setOpenIndex(isOpen ? null : idx)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-66">
                  <span className="font-bold text-navy-900 pr-4" data-id="element-67">{faq.q}</span>
                  <motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} transition={{
                duration: 0.2
              }} data-id="element-68">
                    <ChevronDown className="text-navy-400" data-id="element-69" />
                  </motion.div>
                </button>
                <AnimatePresence data-id="element-70">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-71">
                      <div className="px-6 pb-5 text-navy-600 border-t border-navy-50 pt-4" data-id="element-72">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}